
import React, { Component } from 'react';
import './cw-confirmation-modal.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'

class ArchiveComponent extends Component {

    onClickOkay = () => {
        this.props.onOk && this.props.onOk()
    }

    onCLickCancel = () => {
        this.props.close && this.props.close()
    }

    render() {
        return (
            <Modal className="cw-custom-modal" keyboard = {false} backdrop = 'static' isOpen={true} toggle={this.props.close} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="cw-confirm-v2">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.close} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        {
                            this.props.from === 'view_answer' ? <></>
                                :
                                <div className="text-center">
                                    <div className="title"><b>Confirm</b></div>
                                </div>
                        }



                        <div className="text-center">
                            <div className="title">{this.props.message || "Are you sure you want to do this action?"}</div>
                        </div>
                        {this.props.description &&
                            <div className="text-center">
                                <div className="title">{this.props.description}</div>
                            </div>
                        }
                        <div className="text-center py-4">
                            <button className="cw-button-primary light mr-2" onClick={this.onCLickCancel}>
                                Cancel
                            </button>
                            <button className="cw-button-primary" onClick={this.onClickOkay}>
                                OK
                            </button>
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default ArchiveComponent;